import clsx from "clsx";
import EmptyAssetCard from "common/features/asset/EmptyAssetCard";
import { FormattedMessage } from "react-intl";
import styles from "./DefaultErrorAssetCard.module.scss";
import MiscellaneousExclamationCircle from "common/icons/MiscellaneousExclamationCircle";

export default function DefaultErrorAssetCard({
  className,
}: {
  className?: string;
}) {
  return (
    <EmptyAssetCard type="auto" vbid="" tagName="li">
      <div className={clsx(className, styles.cardError)}>
        <MiscellaneousExclamationCircle />
        <FormattedMessage defaultMessage="Something went wrong while loading this item." />
      </div>
    </EmptyAssetCard>
  );
}
